
  import createMeisterIcons from '../src/createMeisterIcons';

  const AndroidPhone = createMeisterIcons("android-phone", [["path",{"fill":"currentColor","d":"M5.75 7A3.26 3.26 0 0 1 9 3.75h6A3.26 3.26 0 0 1 18.25 7v10A3.26 3.26 0 0 1 15 20.25H9A3.26 3.26 0 0 1 5.75 17zM9 2.25A4.76 4.76 0 0 0 4.25 7v10A4.76 4.76 0 0 0 9 21.75h6A4.76 4.76 0 0 0 19.75 17V7A4.76 4.76 0 0 0 15 2.25zm2.5 15a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5z","key":"73dee091d1125b63b3a1b05d721080701689ee22","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default AndroidPhone
  